import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {getLogoSrc} from "../../utils/Utils";

import './EndLanding.css';
import Mousetrap from "mousetrap";

@inject("appStore")
@observer
class EndLanding extends Component {

    componentDidMount = () => {
        window.removeEventListener("beforeunload", this.props.appStore.exitConfirmation);
    };
    componentWillUnmount = () => {
        window.addEventListener("beforeunload", this.props.appStore.exitConfirmation);
    };

    render() {
        const appStoreColor = this.props.appStore.appConfig.content.brand.brandColor;
        const backgroundColor = {
            backgroundColor: `rgba(${ appStoreColor.r }, ${ appStoreColor.g }, ${ appStoreColor.b }, ${ appStoreColor.a })`
        };
        return (
            <div className={(this.props.appStore.isMobile) ? "EndLanding mobile" : "EndLanding desktop"}
                 style={backgroundColor}>
                <div className="container">
                    {this.props.appStore.appConfig.content.thankyou.displayLogo &&
                    <div className="logo">
                        <img src={getLogoSrc(this.props.appStore.appConfig.content.brand.logo)}/>
                    </div>}
                    <div className="content">
                        <h2 className="header">{this.props.appStore.appConfig.content.thankyou.headline}</h2>
                        <p className="copy">
                            {this.props.appStore.appConfig.content.thankyou.text}
                        </p>
                    </div>
                    {this.props.appStore.appConfig.content.thankyou.link &&
                    <a href={this.props.appStore.appConfig.content.thankyou.link} className="take-again">
                        {this.props.appStore.appConfig.content.thankyou.label}
                    </a>}
                </div>
            </div>
        );
    }
}

export default EndLanding;


// WEBPACK FOOTER //
// ./src/scenes/EndLanding/index.js